// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pE5dMGCxMoQNpNlQlq5d{color:var(--content-negative-primary)}.aA2VNAgsIMVkCVB7s1uR{background-color:#3eb786;border-radius:8px;width:8px;height:8px;margin:0 8px;display:block}.vYJm8LLHEIRKLYmuJu4s{align-items:center;height:100%;display:flex}.bQzDe60Y64H6NXs_Imbf{align-items:center;width:18px;margin:0 8px;display:flex;position:relative}.bQzDe60Y64H6NXs_Imbf ._HRlkCRgWtsdgCsQgLjZ{border:2px var(--background-primary-inverted-primary)solid;background-color:#3eb786;border-radius:8px;width:10px;height:10px;display:block;position:absolute}.SaHqndMyWlw_7O2b0ATn{color:var(--content-primary-primary);font-size:13px;font-weight:400;line-height:normal}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"warning": `pE5dMGCxMoQNpNlQlq5d`,
	"color": `aA2VNAgsIMVkCVB7s1uR`,
	"countLabelWrapper": `vYJm8LLHEIRKLYmuJu4s`,
	"countColors": `bQzDe60Y64H6NXs_Imbf`,
	"countColor": `_HRlkCRgWtsdgCsQgLjZ`,
	"countLabel": `SaHqndMyWlw_7O2b0ATn`
};
export default ___CSS_LOADER_EXPORT___;
